import React from 'react';
import Lottie from 'lottie-react';
import flow888Animation from '../../assets/images/flow888.json';
import nova7Logo from '../../assets/images/nova7.png';
import gg888Logo from '../../assets/images/gg888.png';
import crackerLogo from '../../assets/images/cracker.png';
import { BrandType, getDomainBrand } from '../../utils/getDomainBrand';

const BRAND_LOGOS: Record<Exclude<BrandType, 'flow888'>, string> = {
  nova7: nova7Logo,
  gg888: gg888Logo,
  crackerjackpot: crackerLogo,
};

interface BrandLogoProps {
  className?: string;
}

// The current domain's logo: flow888 is an animation, the other brands are images.
const BrandLogo: React.FC<BrandLogoProps> = ({ className }) => {
  const brand = getDomainBrand();
  return brand === 'flow888' ? (
    <Lottie className={className} animationData={flow888Animation} loop autoplay />
  ) : (
    <img src={BRAND_LOGOS[brand]} alt={brand} className={className} />
  );
};

export default BrandLogo;
